	import { Location } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpClientService } from '../../Services/http-client.service';
import { SessionService } from '../../Services/session.service';
import { AppSettings } from '../../app-settings';
import { EventService } from "../../Services/event.service";
@Component({
  selector: 'app-extension-terms',
  templateUrl: './extension-terms.component.html',
  styleUrls: ['./extension-terms.component.css']
})
export class ExtensionTermsComponent implements OnInit, OnDestroy {
  loadingCircleURL = AppSettings.loadingCircleImageURL;
  userInfoSubscription:Subscription;
  userEmail:string;
  paidUser:boolean=true;
	dataAvailable:boolean=false;
	extensionHeader:string="";
	extensionCourseName:string="";
	extensionOptions:string="";
	extensionAutoRenewPeriod:string="";
	extensionPurchaseWindow:string="";
	extensionButtonLabel:string="";
	repurchaseButtonLabel2Months:string="";
	repurchaseDurationLabel2Months:string="";
	repurchaseButtonLabel4Months:string="";
	repurchaseDurationLabel4Months:string="";
	extensionButtonDisabled:boolean=true;
	numberOfCheckedTnC:number=0;
	packageId:string='';
	autoRenewDuration:string='';
	purchaseDurationWindow:string='';
	extensionOffersString:string='';
	extensionLink:string='';
	catchAllPageURL:string='https://e-gmat.com/extend-course-exception/';
	finalDateToPurchase:any;
	repurchasePackage4Months = {};
	repurchasePackage2Months = {};
	showRepurchaseLink = false;
	repurchaseLinkClicked = false;
	extensionTncConfig=[
		{
			"term":"I have read and accept the above terms and conditions",
			"checked":false
		},
		{
			"term":"I certify that I am the original owner of this account and I am not participating in account sharing activities.<br>Legal action may be taken against me if I am found to be doing so.",
			"checked":false
		},
	];
	repurchaseTncConfig=[
		{
			"term":"I have read and accept the above terms and conditions",
			"checked":false
		}
	];
	extensionAction:string="";
	extensionHeaderConfig:object={
		"EXTENSION":{
			"header":"Extend your Access",
			"buttonLabel":"Extend Access",
			"showPrice":false
		},
		"REPURCHASE":{
			"header":"Repurchase Course",
			"buttonLabel":"Repurchase",
			"showPrice":true
		}
	};

  constructor(private httpClientService: HttpClientService , private sanitizer: DomSanitizer,private router:Router,private readonly location: Location , private sessionService: SessionService, private eventService: EventService) {
   }

  ngOnInit()
  {
		this.getExtensionDetail();
		this.getFullName();
  }

	getExtensionDetail()
	{
		this.httpClientService.get(AppSettings.restApiUrl+'/api/user/extension/configuration', new HttpHeaders()).subscribe((data)=>{
			if(data)
			{
				this.extensionAction = data.extensionAction;
				this.finalDateToPurchase = data.purchaseEndDate;
				if(data.manualHelpRequired)
				{
					window.location.href = this.catchAllPageURL;
				}
				else
				{
					if(this.extensionAction!='NA')
					{
					 this.setTemplateData(data);
					 if(this.extensionAction=="REPURCHASE")
					 {
						// this.extensionLink = data.extensionOffers[0]['extensionLink'];
						 this.fetchRepurchasePackages();
					 }
					 if(this.extensionAction=="EXTENSION")
					 {
						this.displayRepurchaseLink(new Date(data.subscriptionEndDate)); //actual code
						 //this.displayRepurchaseLink(new Date(1699230350000)); //test code
						 this.extensionButtonLabel = this.extensionHeaderConfig[this.extensionAction]['buttonLabel'];
						/* this.extensionButtonLabel = this.extensionHeaderConfig[this.extensionAction]['buttonLabel'] + " "+ this.extensionCourseName;
						 if(this.extensionHeaderConfig[this.extensionAction]['showPrice'])
						 {
							 this.extensionButtonLabel += " - US $" + data.extensionOffers[0]['price'];
						 }*/
					 }
		 			 this.extensionHeader = this.extensionHeaderConfig[this.extensionAction]['header'];
		 			
				 	}
				 else
				 {
					 	this.paidUser = false;
				 }
				 this.dataAvailable=true;
				}
			}
		});
	}
	displayRepurchaseLink(oldDate:Date){
		let today = new Date();
		let days = this.dateDiffInDays(oldDate, today);
		//console.log("difference in days :::"+days);
		if(days > 62)
			this.showRepurchaseLink = true;
	}

	dateDiffInDays(a, b) {
		const _MS_PER_DAY = 1000 * 60 * 60 * 24;
		// Discard the time and time-zone information.
		const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
		const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
	  
		return Math.floor((utc2 - utc1) / _MS_PER_DAY);
	  }

	  showRepurchaseScreen(){
		this.repurchaseLinkClicked = true;
		this.extensionAction="REPURCHASE";
		//this.extensionLink = null; //for extension, these values are usually null
		this.fetchRepurchasePackages();
		this.extensionHeader = this.extensionHeaderConfig[this.extensionAction]['header'];
	  }

	  goBackToExtensionScreen(){
		this.repurchaseLinkClicked = true;
		this.extensionAction="EXTENSION";
		this.extensionHeader = this.extensionHeaderConfig[this.extensionAction]['header'];
	  }

	fetchRepurchasePackages(){
		this.httpClientService.get(AppSettings.restApiUrl+'/api/package/fetchRepurchasePackages', new HttpHeaders()).subscribe((data)=>{
			for(var i=0;i< data.length;i++){
				if(data[i].courseName == "GMAT Online Intensive Repurchase"){
					this.repurchasePackage4Months = data[i];
				}
				else if(data[i].courseName == "GMAT Online Focused Repurchase"){
					this.repurchasePackage2Months = data[i];
				}						
			}

			this.repurchaseButtonLabel4Months = this.repurchasePackage4Months["courseName"].replace("Repurchase","").trim() + " - US $" + this.repurchasePackage4Months["packagePrice"];
			this.repurchaseDurationLabel4Months = Math.round(this.repurchasePackage4Months["durationInDays"] / 30) + " Month Access";

			this.repurchaseButtonLabel2Months = this.repurchasePackage2Months["courseName"].replace("Repurchase","").trim() + " - US $" + this.repurchasePackage2Months["packagePrice"];
			this.repurchaseDurationLabel2Months = Math.round(this.repurchasePackage2Months["durationInDays"] / 30) + " Month Access";
		});
	}

	setTemplateData(data)
	{
		this.extensionCourseName=data.packageName;
		this.packageId=data.packageId;
		this.purchaseDurationWindow = data.purchaseDurationWindow;
		let extensionOffers = data.extensionOffers;
		this.extensionOffersString = this.setExtensionsOffers(extensionOffers);

	}
	setExtensionsOffers(extensionOffers)
	{
		let offerString = "a ";
		if(extensionOffers)
		{

			for (let index = 0; index < extensionOffers.length; index++)
			{
				let offer = extensionOffers[index];
				offerString += offer['duration'] + " Extension for US $" + offer['price'];
				if(index==extensionOffers.length-1)
				{
							offerString += " ";
				}
				else
				{
						offerString += " or a ";
				}
			}
		}
		else
		{
		  offerString = " ";
		}
		return offerString.trim();
	}
	validateTnC(event,index)
	{
		let checked = event.target.checked;
		let maxNumberOfTnC;
		if(this.extensionAction=="EXTENSION")
		{
				this.extensionTncConfig[index]['checked'] = checked;
				maxNumberOfTnC = this.extensionTncConfig.length;
		}
		else
		{
				this.repurchaseTncConfig[index]['checked'] = checked;
				maxNumberOfTnC = this.repurchaseTncConfig.length;
		}
		let numberOfCheckedTnC = this.getNumberOfCheckedTnC();
		if(numberOfCheckedTnC == maxNumberOfTnC)
		{
			this.extensionButtonDisabled=false;
		}
		else
		{
			this.extensionButtonDisabled=true;
		}
	}
	getNumberOfCheckedTnC()
	{
		let extensionTncConfig;
		if(this.extensionAction=="EXTENSION")
		{
			extensionTncConfig = this.extensionTncConfig;
		}
		else
		{
			extensionTncConfig = this.repurchaseTncConfig;
		}
		return extensionTncConfig.filter(function(item){
			return item['checked'];
		}).length;

	}

	redirectToExtendCourse(name: String)
	{
		this.fireTermsConditionAcceptedEvent();
		if(this.extensionAction=="EXTENSION"){
			let configObj = {
				'extensionAction':this.extensionAction,
				'packageId':this.packageId,
				'buttonLabel':this.extensionButtonLabel
			};
			let encodedConfig = btoa(JSON.stringify(configObj));
			this.router.navigateByUrl('/extend-course/'+encodedConfig);
		}
		else if( this.extensionAction=="REPURCHASE"){
			let configObj ={};
			if(name == "FOCUSED"){
				configObj = {
					'extensionAction':this.extensionAction,
					'packageId':this.repurchasePackage2Months["courseId"],
					'buttonLabel':this.repurchaseButtonLabel2Months,
					'buttonDurationLabel':this.repurchaseDurationLabel2Months
				};
			}
			else if(name == "INTENSIVE"){
				configObj = {
					'extensionAction':this.extensionAction,
					'packageId':this.repurchasePackage4Months["courseId"],
					'buttonLabel':this.repurchaseButtonLabel4Months,
					'buttonDurationLabel':this.repurchaseDurationLabel4Months
				};
			}
			
			//console.log("config obj:::::",configObj);
			let encodedConfig = btoa(JSON.stringify(configObj));
			this.router.navigateByUrl('/extend-course/'+encodedConfig);
		}
		else
		{
			setTimeout(()=>{
					window.location.href=this.extensionLink;
			},500);
		}
	}

	fireTermsConditionAcceptedEvent()
	{
		let eventName= "Terms_Conditions_Action";
		let properties={
			"tc_action": "agreed",
			"tc_action_source": "course_repurchase_flow",
			"course_name": this.extensionCourseName
		};
		this.eventService.track(eventName, properties);
	}

  getFullName()
  {

    this.userInfoSubscription = this.sessionService.getUserInfo$.
    subscribe(data => {
		 if(data != "")
		 {
	     this.userEmail = data.username;
	     if(this.userEmail)
	     {
	        this.fireAccessedEvent();
	     }
	 	 }
      });

   }

  fireAccessedEvent()
  {
    this.eventService.track('Accessed_User_Info', {"Accessed_Reason":"extensions"}, this.userEmail);
  }

  @HostListener('unloaded')
  ngOnDestroy(): void {
    this.userInfoSubscription.unsubscribe();
  }

}
